/* eslint-disable react/no-danger */
import React from 'react';
import { Link } from 'react-router-dom';

import styles from './SitemapSection.scss';

type SitemapSectionProps = {
  data: { link: string; title: string}[];
  header?: string;
}

const SitemapSection = ({ data, header }: SitemapSectionProps) => (
  <section className={styles.component}>
    {header && <h2>{header}</h2>}
    <div>
      <ul>
        {data.map(({ link, title }) => (
          <li key={link}>
            <Link to={link}>
              <span dangerouslySetInnerHTML={{ __html: title }} />
            </Link>
          </li>
        ))}
      </ul>
    </div>
  </section>
);

export default SitemapSection;
